import { CostCodeCostTypeBase } from './base/cost-code-cost-type-base';

export class CostCodeCostType extends CostCodeCostTypeBase { }